export const CARDS = 'resource.cards';
export const THRIVEPATHWAY = 'resource.thrive-pathway';
export const THRIVEASSESSMENT = 'resource.thrive-assessment';
